
import Cookies from 'js-cookie'
import { computed, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { LEGAL_LINKS } from '@/config/legal'
import { BOTTLE_WEBSITE_URL } from '@/config/website'
import { clearAuthToken } from '@/helpers/authToken'
import { signupStepUrls } from '@/helpers/signupSteps'
import convertEmailService from '@/services/convertEmail.service'
import api from '@/store/api'

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    imagePosition: {
      type: String,
      required: false,
      default: 'left'
    },
    maxWidth: {
      type: String,
      required: false,
      default: 'md:max-w-3xl'
    },
    /** When provided, the back button calls this instead of linking to bottle.com */
    backClickHandler: {
      type: Function,
      required: false,
      default: null
    },
    /** When true, hides both the back/home button and the logout button */
    hideNavigation: {
      type: Boolean,
      required: false,
      default: false
    },
    /** When true, hides only the top-left back/home control; Log out remains visible */
    hideBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /** When true, hides the Log out button (e.g. when user is not logged in) */
    hideLogOut: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, context) {
    const formSubmitted = () => {
      context.emit('form-submitted')
    }

    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const logOut = () => {
      convertEmailService.clear()
      clearAuthToken()
      router.push('/login').then(() => {
        store.commit('RESET_STATE')
      })
    }

    const inSignupJourney = computed(() => signupStepUrls.includes(route.path))

    // The reset failing (expired token, dead account) must not trap the user in
    // the journey, so the local session is cleared no matter what it returns.
    const startOver = () => {
      const onboardingToken = Cookies.get('onboarding_auth_token')
      const resetRequest = onboardingToken
        ? api.call('POST', 'onboarding/reset', {}, { authToken: onboardingToken, receive: false }).catch(() => {})
        : Promise.resolve()

      resetRequest.then(() => {
        convertEmailService.clear()
        Cookies.remove('onboarding_auth_token')
        clearAuthToken()
        sessionStorage.removeItem('signupPassword')
        store.dispatch('clearSignUpPropertyValues')
        window.location.href = '/sign-up'
      })
    }

    return {
      props,
      formSubmitted,
      logOut,
      startOver,
      inSignupJourney,
      route,
      LEGAL_LINKS,
      BOTTLE_WEBSITE_URL
    }
  }
})
